import React, { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/navBar';

const MagazineViewer = () => {
  const [magazine, setMagazine] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchMagazine = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/magazines/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        setMagazine(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch magazine');
        setLoading(false);
      }
    };

    fetchMagazine();
  }, [id]);

  if (loading) return <div className="text-white">Loading...</div>;
  if (error) return <div className="text-white">{error}</div>;
  if (!magazine) return <Navigate to="/magazines" />;

  return (
    <div className="bg-gray-900 min-h-screen">
      <Navbar />
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 text-white">{magazine.bookName}</h1>
        <div 
          className="relative w-full pt-[133%] sm:pt-[100%] md:pt-[75%] lg:pt-[56.25%] bg-gray-800 rounded-lg shadow-lg overflow-hidden"
        >
          <iframe
            src={`${process.env.REACT_APP_API_URL}/magazines/secure-viewer/${id}#toolbar=0`}
            title={magazine.bookName}
            className="absolute top-0 left-0 w-full h-full border-0"
            allowFullScreen
            onContextMenu={(e) => e.preventDefault()}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default MagazineViewer; 